import React from 'react';

const STATUS_CONFIG = {
  // Lowercase service values
  new: { label: 'New Lead', className: 'bg-blue-100 text-blue-800' },
  contacted: { label: 'Contacted', className: 'bg-purple-100 text-purple-800' },
  qualified: { label: 'Qualified', className: 'bg-amber-100 text-amber-800' },
  proposal_sent: { label: 'Proposal Sent', className: 'bg-orange-100 text-orange-800' },
  negotiating: { label: 'Negotiating', className: 'bg-indigo-100 text-indigo-800' },
  won: { label: 'Converted', className: 'bg-green-100 text-green-800' },
  lost: { label: 'Lost', className: 'bg-red-100 text-red-800' },
  on_hold: { label: 'On Hold', className: 'bg-gray-100 text-gray-700' },
  // Title Case DB values (fallback)
  'New Lead': { label: 'New Lead', className: 'bg-blue-100 text-blue-800' },
  'Contacted': { label: 'Contacted', className: 'bg-purple-100 text-purple-800' },
  'Qualified': { label: 'Qualified', className: 'bg-amber-100 text-amber-800' },
  'Proposal Sent': { label: 'Proposal Sent', className: 'bg-orange-100 text-orange-800' },
  'Negotiating': { label: 'Negotiating', className: 'bg-indigo-100 text-indigo-800' },
  'Converted': { label: 'Converted', className: 'bg-green-100 text-green-800' },
  'Lost': { label: 'Lost', className: 'bg-red-100 text-red-800' },
  'On Hold': { label: 'On Hold', className: 'bg-gray-100 text-gray-700' },
};

const ProspectStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG?.[status] || { label: status || 'Unknown', className: 'bg-gray-100 text-gray-700' };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config?.className}`}>
      {config?.label}
    </span>
  );
};

export default ProspectStatusBadge;
